import React from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import {
    NotificationCategory,
    NotificationContent,
    NotificationDescription,
    NotificationHeader,
    NotificationItemButton,
    NotificationItemRoot,
    NotificationRowAction,
    NotificationTime,
    NotificationTitle,
    UnreadDot,
} from './styled'

export default function NotificationListItem({ notification, onClick, unreadLabel }) {
    return (
        <NotificationItemRoot>
            <NotificationItemButton onClick={() => onClick(notification)}>
                {notification.unread ? <UnreadDot aria-label={unreadLabel} /> : <UnreadDot $read aria-hidden="true" />}

                <NotificationContent>
                    <NotificationHeader>
                        <NotificationCategory>{notification.category}</NotificationCategory>
                        <NotificationTime dateTime={notification.createdAt || undefined}>
                            {notification.relativeTime}
                        </NotificationTime>
                    </NotificationHeader>
                    <NotificationTitle $unread={notification.unread}>{notification.title}</NotificationTitle>
                    <NotificationDescription>{notification.description}</NotificationDescription>
                </NotificationContent>

                <NotificationRowAction aria-hidden="true">
                    <ChevronRightIcon fontSize="small" />
                </NotificationRowAction>
            </NotificationItemButton>
        </NotificationItemRoot>
    )
}
